export function usePhoneSupportEnabled() {
  const phoneSupportEnabled = false
  return { phoneSupportEnabled }
}
